import { computed, Ref } from 'vue'
import Fuse from 'fuse.js'

interface ActionItem {
  name: string
  value: string
  tags: string[]
}

export function useCommandPaletteSearch(
  actions: Ref<ActionItem[]>,
  query: Ref<string>,
  keys: string[] = ['name', 'value', 'tags'], // ✅ Keys por defecto
) {
  const fuse = computed(() => {
    return new Fuse(actions.value, {
      keys,
      includeScore: true,
      includeMatches: true,
      threshold: 0.4,
      minMatchCharLength: 2,
    })
  })

  const filteredActions = computed(() => {
    if (!query.value.trim()) return actions.value

    const results = fuse.value.search(query.value)

    const ranked = results.map(result => {
      let bonus = 0
      const keywords = query.value.toLowerCase().split(/\s+/).filter(Boolean)

      keywords.forEach(keyword => {
        if ((result.item.name || '').toLowerCase().startsWith(keyword))
          bonus += 0.2
        if ((result.item.value || '').toLowerCase().startsWith(keyword))
          bonus += 0.1
      })

      return {
        ...result,
        finalScore: 1 - (result.score ?? 1) + bonus,
      }
    })

    const finals = ranked
      .sort((a, b) => b.finalScore - a.finalScore)
      .map(item => ({
        ...item.item,
        highlights: getHighlights(item.matches),
      }))

    return finals.length ? finals : actions.value
  })

  const getHighlights = (
    matches: readonly Fuse.FuseResultMatch[] | undefined,
  ) => {
    if (!matches) return {}
    const highlights: Record<string, number[][]> = {}
    matches.forEach(match => {
      highlights[match.key as string] = match.indices
    })
    return highlights
  }

  return {
    filteredActions,
  }
}
